// Brand-specific upsell component extended from
// common upsell component with global functionality
export default (commonUpsell) =>
  ({
    offerPath,
    paymentsPath,
    paymentsFailPath,
    paymentsSuccessPath,
    sendOffPath
  } = {}) => ({

    // Init common upsell functionality

    ...commonUpsell({
      upsellOfferType: "shopping_list_and_premium",
      offerPath,
      paymentsPath,
      paymentsFailPath,
      paymentsSuccessPath,
      sendOffPath
    }),

    // Add or overwrite brand-specific functionality

  })
